var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,26A13,13,0,1,1,26,13,13,13,0,0,1,13,26ZM13,2A11,11,0,1,0,24,13,11,11,0,0,0,13,2Z",
    fill: "#4F7DBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76,18.24a1,1,0,0,1-.71-1.7l8.49-8.49A1,1,0,1,1,18,9.46L9.46,18A1,1,0,0,1,8.76,18.24Z",
    fill: "#4F7DBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.24,18.24a1,1,0,0,1-.7-.29L8.05,9.46A1,1,0,0,1,9.46,8.05L18,16.54A1,1,0,0,1,18.05,18L18,18A1,1,0,0,1,17.24,18.24Z",
    fill: "#4F7DBF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9623f4e356ca0a81c646f5e2fb259395.svg";
export { ForwardRef as ReactComponent };